// Local translations
export const T = {
  en_GB: {
    change: "Change",
    changeOrganization: "Change organization",
    lastUsedOrganization: "Last used organization",
  },
  nb_NO: {
    change: "Bytt",
    changeOrganization: "Bytt organisasjon",
    lastUsedOrganization: "Sist brukte organisasjon",
  },
} as const;
